// ;(function($){

	  // $(function(){

	  	if( $('.storyslider-wrapper').length > 0 ){



	  							// tiny helper function to add breakpoints
				function getGridSize() {
					if( $('.storyslider').hasClass('theme-wftlook') ){
						if (window.innerWidth < 768) {
							return 1; // mobile
						// } else if (window.innerWidth < 1024) {
						} else if (window.innerWidth < 1800) {
							return 3; // tablet
						} else {
							return 5; // desktop
						}
					}else{
						if (window.innerWidth < 768) {
							return 1; // mobile
						} else if (window.innerWidth < 1024) {
							return 3; // tablet
						} else {
							return 3; // desktop
						}
					}
				}




				 window.addCurrentSlidesClassStoryslider = function (slider) {
				    //debugger;
				    $('.storyslider-wrapper li').removeClass("active-slides");
				    var startli = (slider.move * (slider.currentSlide));
				    var endli = (slider.move * (slider.currentSlide + 1));
				    for (i = startli + 1; i <= endli; i++) {
				        $('.storyslider-wrapper li:nth-child(' + i + ')').addClass('active-slides');
				    }
				}

				// BITV/WCAG: Fix ARIA roles for auto-generated FlexSlider navigation controls
				function fixStorysliderAriaRoles(slider) {
					$('.storyslider-wrapper').each(function() {
						var $wrapper = $(this);
						var $nav = $wrapper.find('.flex-control-nav');
						
						if ($nav.length > 0) {
							// Set role="group" on the ol/ul
							$nav.attr('role', 'group').attr('aria-label', 'Bildauswahl');
							
							// Update buttons/links inside li
							$nav.find('li a').each(function(index) {
								var $link = $(this);
								var currentSlide = slider.currentSlide || 0;
								
								// Add role="button" if not present
								if (!$link.attr('role')) {
									$link.attr('role', 'button');
								}
								
								// Update aria-current
								if ($link.hasClass('flex-active') || index === currentSlide) {
									$link.attr('aria-current', 'page');
								} else {
									$link.attr('aria-current', 'false');
								}
							});
						}
					});
				}

				// BITV/WCAG: Update button states for storyslider
				function updateStorysliderButtonStates(slider) {
					$('.storyslider-wrapper').each(function() {
						var $wrapper = $(this);
						var $nav = $wrapper.find('.flex-control-nav');

						if ($nav.length > 0) {
							var currentSlide = slider.currentSlide || slider.animatingTo || 0;
							$nav.find('li a').each(function(index) {
								var $link = $(this);
								if (index === currentSlide) {
									$link.attr('aria-current', 'page').attr('tabindex', '0');
								} else {
									$link.attr('aria-current', 'false').attr('tabindex', '-1');
								}
							});
						}
					});
				}

				// BITV/WCAG: Initialize keyboard navigation for storyslider
				function initializeStorysliderKeyboardControls(slider) {
					$('.storyslider-wrapper').each(function() {
						var $wrapper = $(this);
						var $nav = $wrapper.find('.flex-control-nav');

						if ($nav.length > 0) {
							// Remove any existing keyboard handlers to prevent duplicates
							$nav.find('li a').off('keydown.storysliderKeyboard');
							
							$nav.find('li a').each(function(index) {
								var $link = $(this);
								
								// Make sure link is focusable
								if (!$link.attr('tabindex')) {
									$link.attr('tabindex', index === slider.currentSlide ? '0' : '-1');
								}

								// Handle keyboard navigation
								$link.on('keydown.storysliderKeyboard', function(e) {
									var currentIndex = slider.currentSlide;
									var totalSlides = slider.count;
									
									switch(e.key) {
										case 'ArrowRight':
											e.preventDefault();
											var nextIndex = (currentIndex + 1) % totalSlides;
											slider.flexAnimate(nextIndex);
											// Update focus to the new active button
											setTimeout(function() {
												$nav.find('li a').eq(nextIndex).focus();
											}, 100);
											break;
										case 'ArrowLeft':
											e.preventDefault();
											var prevIndex = (currentIndex - 1 + totalSlides) % totalSlides;
											slider.flexAnimate(prevIndex);
											// Update focus to the new active button
											setTimeout(function() {
												$nav.find('li a').eq(prevIndex).focus();
											}, 100);
											break;
										case 'Home':
											e.preventDefault();
											slider.flexAnimate(0);
											// Update focus to the first button
											setTimeout(function() {
												$nav.find('li a').eq(0).focus();
											}, 100);
											break;
										case 'End':
											e.preventDefault();
											slider.flexAnimate(totalSlides - 1);
											// Update focus to the last button
											setTimeout(function() {
												$nav.find('li a').eq(totalSlides - 1).focus();
											}, 100);
											break;
										case 'Enter':
										case ' ':
											// Allow default behavior (click) for Enter and Space
											break;
									}
								});
							});
						}
					});
				}




	            $('.storyslider-wrapper').flexslider({
	              animation: "slide",
	              animationLoop: false,
	              slideshow: false,
	              controlNav: true,
	              directionNav: true,
	              itemWidth: 332,
	              itemMargin: 15,
	              minItems: getGridSize(),
				  maxItems: getGridSize(),
    			  start: function(slider) { // Fires when the slider loads the first slide
    			  	// BITV/WCAG: Fix ARIA roles for auto-generated navigation controls
    			  	fixStorysliderAriaRoles(slider);
    			  	updateStorysliderButtonStates(slider);
    			  	initializeStorysliderKeyboardControls(slider);
				  	$('.storyslider-wrapper').css({ "visibility": "visible", "max-height": "9999px", "overflow": "visible" });
				  	if (typeof $.fn.matchHeight === 'function') {
				  		$('.storyslider-wrapper .teasertext').matchHeight();
				  	}

//	                var slide_count = slider.count - 1;
//	                $(slider)
//	                    .find('img.lazy:nth-child(-n+3)')
//	                    .each(function() {
//	                      var src = $(this).attr('data-src');
//	                      $(this).attr('src', src).removeAttr('data-src');
//	                    });
	                    window.addCurrentSlidesClassStoryslider(slider);
	               },
	               before: function(slider) { // Fires asynchronously with each slider animation
//	                  var slides     = slider.slides,
//	                      index      = slider.animatingTo,
//	                      $slide     = $(slides[index]),
//	                      $img       = $slide.find('img[data-src]'),
//	                      current    = index,
//	                      nxt_slide  = current + 1,
//	                      prev_slide = current - 1;
//
//	                  $slide
//	                    .parent()
//	                    .find('img.lazy:eq(' + current + '), img.lazy:eq(' + prev_slide + '), img.lazy:eq(' + nxt_slide + ')')
//	                    .each(function() {
//	                      var src = $(this).attr('data-src');
//	                      $(this).attr('src', src).removeAttr('data-src');
//	                    });
	               },
	               after: function(slider){
	               		// BITV/WCAG: Update ARIA roles after slide change
	               		fixStorysliderAriaRoles(slider);
	               		updateStorysliderButtonStates(slider);
	               		window.addCurrentSlidesClassStoryslider(slider);
	               }
	            });

	            $('.storyslider-wrapper').each(function(){
	            	//position navigation arrows
            		var flexWidth = $(this).width();
            		var flexHeight = (((flexWidth - 10) / 3) * 927) / 900 ;
            		var arrowPositionTop = flexHeight/2;
            		$(this).closest('.storyslider-wrapper').find('.flex-direction-nav').css('top',arrowPositionTop+'px');
					
	            });


	             function show_hide_nav(){
		            $('.storyslider-wrapper').each(function(){
		            	var slideCount = $(this).find('.slide').length;
		            	var isWftTheme = $(this).closest('.storyslider').hasClass('theme-wftlook');

		            	if( window.innerWidth < 768 ){
		            		// Mobile: always hide navigation
		            		$(this).find('.flex-direction-nav').hide();
		            	} else if( window.innerWidth < 1024 ){
		            		// Tablet: hide if 3 or fewer slides
		            		if( slideCount <= 3 ){
		            			$(this).find('.flex-direction-nav').hide();
		            		}
		            	} else {
		            		// Desktop: hide based on theme and slide count
		            		if( !isWftTheme && slideCount < 4 ){
		            			$(this).find('.flex-direction-nav').hide();
		            		}
		            		if( isWftTheme && slideCount > 3 ){
								$(this).closest('.storyslider').addClass('has-many-slides');
							}
		            		if( isWftTheme && slideCount < 6 ){
		            			$(this).find('.flex-direction-nav').hide();
		            		}
		            	}
		            });

	            }
	            show_hide_nav();

	            function storysliderInit(){

							if( $('.storyslider-wrapper').attr('data-flexslider-doing') != 'true' || $('.storyslider-wrapper').attr('data-flexslider-doing') == undefined ){

								$('.storyslider-wrapper').attr('data-flexslider-doing', 'true');

								$('.storyslider-wrapper').removeData('flexslider');
								$('.storyslider-wrapper').find('.flex-direction-nav').remove();
								$('.storyslider-wrapper').find('.flex-control-nav').remove();
								$('.storyslider-wrapper').flexslider({
					              animation: "slide",
					              animationLoop: false,
					              slideshow: false,
					              controlNav: true,
					              directionNav: true,
					              itemWidth: 332,
					              itemMargin: 15,
					              minItems: getGridSize(),
				    			  maxItems: getGridSize(),
				      			  start: function(slider) { // Fires when the slider loads the first slide
				      			  	// BITV/WCAG: Fix ARIA roles for auto-generated navigation controls
				      			  	fixStorysliderAriaRoles(slider);
				      			  	updateStorysliderButtonStates(slider);
				      			  	initializeStorysliderKeyboardControls(slider);
				  				  	$('.storyslider-wrapper').css({ "visibility": "visible", "max-height": "9999px", "overflow": "visible" });
				  				  	if (typeof $.fn.matchHeight === 'function') {
				  				  		$('.storyslider-wrapper .teasertext').matchHeight();
				  				  	}

		//		  	                var slide_count = slider.count - 1;
		//		  	                $(slider)
		//		  	                    .find('img.lazy:nth-child(-n+3)')
		//		  	                    .each(function() {
		//		  	                      var src = $(this).attr('data-src');
		//		  	                      $(this).attr('src', src).removeAttr('data-src');
		//		  	                    });
				  	                    window.addCurrentSlidesClassStoryslider(slider);
				  	               },
				  	               before: function(slider) { // Fires asynchronously with each slider animation
		//		  	                  var slides     = slider.slides,
		//		  	                      index      = slider.animatingTo,
		//		  	                      $slide     = $(slides[index]),
		//		  	                      $img       = $slide.find('img[data-src]'),
		//		  	                      current    = index,
		//		  	                      nxt_slide  = current + 1,
		//		  	                      prev_slide = current - 1;
		//
		//		  	                  $slide
		//		  	                    .parent()
		//		  	                    .find('img.lazy:eq(' + current + '), img.lazy:eq(' + prev_slide + '), img.lazy:eq(' + nxt_slide + ')')
		//		  	                    .each(function() {
		//		  	                      var src = $(this).attr('data-src');
		//		  	                      $(this).attr('src', src).removeAttr('data-src');
		//		  	                    });
				  	               },
				  	               after: function(slider){
				  	               		// BITV/WCAG: Update ARIA roles after slide change
				  	               		fixStorysliderAriaRoles(slider);
				  	               		updateStorysliderButtonStates(slider);
					               		window.addCurrentSlidesClassStoryslider(slider);
					               }
					            });

					            show_hide_nav();


					            setTimeout(function(){
									$('.storyslider-wrapper').attr('data-flexslider-doing','false');
					            },4000);

							}

				}






//	            //responsive Flexslider
//				var resizeTimerStoryslider = false;
//
//				$(window).on('resize', function(e) {
//
//				  if( !resizeTimerStoryslider ) {
//					$(window).trigger('resizestart');  	
//				  }
//
//				  clearTimeout(resizeTimerStoryslider);
//				  resizeTimerStoryslider = setTimeout(function() {
//
//					resizeTimerStoryslider = false;
//					$(window).trigger('resizeend');
//				            
//				  }, 1250);
//
//				}).on('resizestart', function(){
//					// console.log('Started resizing the window');
//				}).on('resizeend', function(){
//					console.log('Done resizing the window');
//
//					storysliderInit();
//					
//				});
//



				$(window).on('load', function(e) {
					storysliderInit();
				});

				

				$('.storysliderLightbox').on('click',function(e){
					e.preventDefault();
					console.log('click');

					$(this).colorbox({inline:true, className: 'storysliderLightboxWrapper', maxWidth: '80%', href: $(this).parent().find('.lightboxContent > div')});
				});

				if (typeof $.fn.matchHeight === 'function') {
					$('.storyslider-wrapper.teasertext').matchHeight();
				}
				
	  	}

	  // });
// })(jQuery);